import { ActionType } from 'flow/store/engine/constants';
import { RuleEditorDropdownMode } from '../../NodeEditorDrawer/types';

export const COMMA_DELINEATOR = ',';
// add spacing to lists when they're displayed for end users
export const COMMA_DELINEATOR_DISPLAY = ', ';

export const validRightSideDynamicComparisonModes = new Set([
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_DATEPICKER,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MAX,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MIN,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_BOOLEAN,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_MULTISELECT,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_REASONCODEGROUP,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_TAGACTIONRESULT,
]);

export const invalidLeftSideDynamicComparisonTypes = new Set([
  ActionType.MATRIX_MODEL, ActionType.TAG, ActionType.OUTCOME_REASON,
]);

export const validRightSideStaticComparisonModes = new Set([
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ACTION,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE,
]);

export const validRangeDropdownModes = new Set([
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MAX,
  RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MIN,
]);

export const minMaxLimitRequiredActionTypes = new Set([
  ActionType.OUTPUT,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.IMPORTED_MATRIX_MODEL,
  ActionType.INPUT,
  ActionType.MATRIX_MODEL,
]);

export const parenthesisDropdownModes = new Set([
  RuleEditorDropdownMode.GROUP_END,
  RuleEditorDropdownMode.GROUP_START,
]);

export const supportedNullActionTypes = new Set([
  ActionType.INPUT,
  ActionType.SERVICE,
]);
